import React from "react";
import "./Solar_Insights.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { SolarInsights } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Solar_Insights = () => {
  const navigate = useNavigate();
  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/events/img-1.png",
      author: "Shreya Mishra",
      date: "13/4/2020",
      title: "How to Plan the Perfect Birthday Celebration",
      desc:
        "Discover creative themes, decoration ideas, and planning tips to make your birthday celebration fun, memorable, and stress-free...",
    },
    {
      id: 2,
      image: "/assets/images/home/events/img-2.png",
      author: "Shreya Mishra",
      date: "13 Apr 2020",
      title: "Top Wedding Trends to Make Your Big Day Special",
      desc:
        "Explore the latest wedding trends, from elegant décor to unique themes, that will make your special day unforgettable...",
    },
    {
      id: 3,
      image: "/assets/images/home/events/img-3.png",
      author: "Shreya Mishra",
      date: "15 Oct 2024",
      title: "Engagement Ceremony Ideas to Celebrate Your Love",
      desc:
        "Get inspired with romantic setups, décor styles, and planning tips to create a beautiful and memorable engagement ceremony...",
    },
    {
      id: 4,
      image: "/assets/images/home/events/img-4.png",
      author: "Shreya Mishra",
      date: "18 Oct 2024",
      title: "Baby Shower Themes That Everyone Will Love",
      desc:
        "From cute and cozy to elegant and stylish, explore baby shower ideas that create a joyful and heartwarming celebration...",
    },
    {
      id: 5,
      image: "/assets/images/home/events/img-5.png",
      author: "Shreya Mishra",
      date: "20 Oct 2024",
      title: "How to Plan a Memorable Anniversary Celebration",
      desc:
        "Celebrate love with thoughtful planning, creative décor, and unique ideas to make your anniversary truly special...",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [solarinsight, setSolarInsight] = useState([]);

  const getSolarInsights = async () => {
    const res = await SolarInsights();
    if (res?.success) {
      setSolarInsight(res.data);
    }
  };
  useEffect(() => {
    getSolarInsights();
  }, []);

  return (
    <section className="Solar_Insights">
      <div className="container">
        <div className="Solar_Insights_header_holder">
          <h5 className="Solar_Insights_header">
            Event Highlights & Latest Updates
          </h5>
          <p className="Solar_Insights_subtitle">
            Exclusive insights, latest trends, and expert guidance to elevate
            your event journey.
          </p>
        </div>
        <div className="blog_grid">
          {solarinsight.map((blog) => (
            <div
              key={blog.id}
              className={`blog_card ${
                blog.id <= 2 ? "blog_card_large" : "blog_card_small"
              }`}
              style={{ backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})` }}
              onClick={() => navigate("/blog")}
            >
              <div className="blog_overlay">
                <div className="blog_meta">
                  <FontAwesomeIcon icon={faUser} style={{ color: "#fff" }} />
                  <span className="author_name">{blog.name}</span>
                  <span className="date">
                    -{" "}
                    {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </div>

                <h3 className="blog_title">{blog.title}</h3>
                <p className="blog_desc">
                  {htmlToReactParser.parse(blog.description)}
                </p>

                <a href="#" className="read_more">
                  Read more
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="view_all_section">
          <div className="view_line"></div>
          <button className="view_all_btn" onClick={() => navigate("/blog")}>
            View all
          </button>
        </div>
      </div>
    </section>
  );
};

export default Solar_Insights;
